'use strict';

import videoBlockTemplate from './videoBlock.html';

export const videoBlockDirName = 'videoBlock';
export function videoBlockDir() {
  return {
    restrict: 'E',
    template: videoBlockTemplate,
    scope: {
      video: '=',
      noLink: '='
    }
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/components/videoBlock/videoBlock.js